import { postWithJson, postWithFormData } from 'library/utils/serviceUtil'
import axios from 'axios'
// 预算明细列表
export const queryBudgetList = params => postWithJson('/budgetDetailTemp/monthDetailList.json', params)

// 获取预算周期
export const queryYearList = (params) => postWithJson(`/budgetYearAdjustApply/queryYearList.json`, params)

// 获取预算单位 预算大类 预算类型 年度
//  查询的数据类型 1全部组织架构[主体-归属-责任中心-一级部门-事业部][不做数据权限控制] 2科目[不做数据权限控制] 3半年度【预算周期】 4年度【预算周期】5组织架构[主体-归属-责任中心-一级部门][做数据权限控制] 6一级部门[做数据权限控制] 7科目[做数据权限控制]
export const getOriTree = params => postWithJson('/budgetDetailTemp/dic/treeList.json', params);

// 查询EHR一级部门
export const getEhrFirstDepts = params => postWithJson('/budgetDetailTemp/getEhrFirstDepts.json', params);

// 下载模板
export const downloadTemplate = (params) => axios.get(`/common/download.json?id=${params.id}`, { responseType: 'arraybuffer' })

// 导入执行数据
export const uploadExecl = (params) => postWithFormData('/operationAetail/importExcel.json', params)

// 导出预算明细列表
export const exportMonthDetailList = params => axios.post('/budgetDetailTemp/exportMonthDetailList.json', params, { responseType: 'arraybuffer' })

// 执行/冻结列表
export const getOperationAetail = params => postWithJson('/operationAetail/list.json', params)
// 预算明细、执行/冻结列表
export const getOperationAetailTotal = params => postWithJson('/operationAetail/getTotal.json', params)

// 获取调整的一级部门
export const getAdjustFirstDeptList = params => postWithJson('/common/adjustFirstDeptList.json', params);
